export default class PropertyMetricNames {
    static GET_BY_ID_ATTEMPT = "GetByIdAttempt";
    static GET_BY_ID_FAILURE = "GetByIdFailure";
    static CREATE_ATTEMPT = "PropertyCreateAttempt";
    static CREATE_FAILURE ="PropertyCreateFailure";
}
